import type { SVGProps } from 'react'

export const FavoriteOutlinedIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M479.62-171.62q-12.85 0-25.81-4.61-12.96-4.62-22.81-14.46l-57.46-52.23q-106.38-97-189.96-190.58Q100-527.08 100-634q0-85.15 57.42-142.58Q214.85-834 300-834q48.38 0 95.58 22.31 47.19 22.31 84.42 72.46 37.23-50.15 84.42-72.46Q611.62-834 660-834q85.15 0 142.58 57.42Q860-719.15 860-634q0 108.08-85 202.73-85 94.65-189.54 188.96l-56.85 51.62q-9.84 9.84-22.99 14.46-13.16 4.61-26 4.61Zm-28.39-506.84q-32.46-49.46-68.35-72.5Q347-774 300-774q-60 0-100 40t-40 100q0 48.15 31.04 100.69t77.92 104.46q46.88 51.93 101.58 101.46 54.69 49.54 101.38 92.08 3.46 3.08 8.08 3.08t8.08-3.08q46.69-42.54 101.38-92.08 54.7-49.53 101.58-101.46 46.88-51.92 77.92-104.46Q800-585.85 800-634q0-60-40-100t-100-40q-47 0-82.88 23.04-35.89 23.04-68.35 72.5-5.08 7.69-12.77 11.54-7.69 3.84-16 3.84-8.31 0-16-3.84-7.69-3.85-12.77-11.54ZM480-502.54Z" />
    </svg>
  )
}
